import { TPaymentItem } from "@src/utils/budget";
import axios from "../axios";
import { BASE_URL } from "@src/utils";

interface IMyBudgetInfo {
    id: number,
    type: string,
    totalPlannedAmount: 135000000,
    totalUsedAmount:number,
    totalRemainingAmount: 135000000,
    categories: [],
    purchases: [],
    upcomingPaymentPurchases: [],
    recommendCategory: string,
    typeAlias: string,
}

//내 웨딩 예산 정보를 조회 (예산 입력/설정, 예산 홈, 구매 내역, 카테고리별 구매 내역, 예산 상세)
export const getMyBudgetInfo = async () => {
  try{
    const res = await axios.get<{ item: IMyBudgetInfo }>(`${BASE_URL}/v4/budgets/wedding`);
    return res.data;
  } catch(err){
    return {...err.response.data, item:{}};
  }
}

export const getBudgetTypeData = async () => {
  try{
    const res = await axios.get(`${BASE_URL}/v4/budgets/wedding/types`);
    return res.data;
  } catch(err){
  }
}

export const putBudgetType = async (type:'ECONOMICAL'|'CONSUMER'|'PREMIUM') => {
  try{
    const res = await axios.put(`${BASE_URL}/v4/budgets/wedding`,{ type: type });
    return res.data;
  } catch(err){

  }
}

// 예산 금액 변경
export const putBudgetPrice= async (data) => {
  try{
    const newData:{category:string, sortOrder:number}[] = data.map(d =>{ 
      return {category:d.category, plannedAmount:d.plannedAmount}
    })
    const res = await axios.put(`${BASE_URL}/v4/budgets/wedding/items/planned-amount`,
      { items: newData});
    return res.data;
  } catch(err){
    console.error('저장 중 오류 발생:', err);
  }
}

// 예산순서 변경
export const putBudgetOrder= async (orderData) => {
  try{
    const data:{category:string, sortOrder:number}[] = orderData.map((order, idx) =>{ 
      return {category:order.category, sortOrder:idx+1}
    })
    const res = await axios.put(`${BASE_URL}/v4/budgets/wedding/items/order`,{ items: data});
    return res.data;
  } catch(err){
    console.error('저장 중 오류 발생:', err);
  }
}

// 예산 초기화
export const initialBudget = async () => {
  try{
    const res = await axios.post<{
      result: string;
      errorCode: number | null;
      errorMessage: string | null;
    }>(`${BASE_URL}/v4/budgets/wedding/items/initialization`);
    return res.data;
  } catch(err){
    console.error('예산 초기화 중 오류 발생:', err);
  }
}


// 구매 내역 추가
export const addPurchase = async (params) => {
  try{
    const date = params.paymentDate.replace(/(\d{4})년 (\d{1,2})월 (\d{1,2})일/, (_, year, month, day) => {
      // 월과 일이 한 자리 수일 경우 앞에 0을 붙임
      const paddedMonth = month.padStart(2, '0');
      const paddedDay = day.padStart(2, '0');
      return `${year}-${paddedMonth}-${paddedDay}`;
    });
    const res = await axios.post(`${BASE_URL}/v4/budgets/wedding/purchases`, {...params, paymentDate:date});
    return res.data;
  } catch(err){
    console.error('예산 초기화 중 오류 발생:', err.response.data);
    return err.response.data;
  }
}



// 구매 내역 정보 조회
export const getPurchaseDetailInfo = async (id) => {
  try{
    const res = await axios.get<{item:TPaymentItem}>(`${BASE_URL}/v4/budgets/wedding/purchases/${id}`);
    return res.data;
  } catch(err){
    return {...err.response.data, item:{}};
  }
}

// 구매 내역 정보 수정
export const updatePurchaseInfo = async (id, params) => {
  try{
    const date = params.paymentDate.replace(/(\d{4})년 (\d{1,2})월 (\d{1,2})일/, (_, year, month, day) => {
      // 월과 일이 한 자리 수일 경우 앞에 0을 붙임
      const paddedMonth = month.padStart(2, '0');
      const paddedDay = day.padStart(2, '0');
      return `${year}-${paddedMonth}-${paddedDay}`;
    });
    const res = await axios.put(`${BASE_URL}/v4/budgets/wedding/purchases/${id}`, {...params, paymentDate:date});
    return res.data;
  } catch(err){
    return err.response.data
  }
}

// 구매 내역 정보 삭제
export const deletePurchase = async (id) => {
  try{
    const res = await axios.delete(`${BASE_URL}/v4/budgets/wedding/purchases/${id}`);
    return res.data;
  } catch(err){
    return err.response.data
  }
}